/**
 * Retornar el canal de una conversación
 * @param {object} user
 * @param {[{channel: string, provider: string}]} user.channels
 *
 * @returns {string}
 */
export const convGetChannel = (user) => {
  const userChannel = user?.channels[0] || {}
  if (userChannel.provider === 'chatmail') {
    return userChannel.provider
  }
  return userChannel.channel || ''
}

/**
 * Retornar el proveedor y el canal de una conversación
 * @param {object} user
 * @param {[{channel: string, provider: string}]} user.channels
 *
 * @returns {string}
 */
export const getChannelAndProvider = (user) => {
  const userChannel = user?.channels[0] || {}

  if (userChannel.provider === 'chatmail') return userChannel.provider

  if (!userChannel.provider) return ''
  if (!userChannel.channel) return ''

  return `${userChannel.provider}__${userChannel.channel}`
}